import React, { useEffect, useState } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Link, Outlet } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import baseUrl from "../../services/api";
import Navbar from "react-bootstrap/Navbar";
import moment from "moment";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../../images/coffee-mug-removebg-preview.png";
import { usePagination } from "@table-library/react-table-library/pagination";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const History = () => {
  const [post, setPost] = useState([]);
  const navigate = useNavigate();
  const session_token = sessionStorage.getItem("token");
const session_role = sessionStorage.getItem("role");

  useEffect(() => {
    var item_value = sessionStorage.getItem("login");
    if (item_value != "1") {
      navigate("/login");
    }
    axios.defaults.headers.common = {
      Authorization: `Bearer ${session_token}`,
    };

  }, []);
  function logout() {
    sessionStorage.removeItem("login");
    sessionStorage.removeItem("name");
    navigate("/login");
  }
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      axios
        .delete(`${baseUrl}/deleteSample/${id}`)
        .then(() => {
          setPost((prevPost) => prevPost.filter((item) => item._id !== id));
          alert("Record deleted successfully!");
        })
        .catch((error) => {
          console.error(error);
          alert("Failed to delete the record.");
        });
    }
  };
  useEffect(() => {
    axios.get(`${baseUrl}/getAllSample`).then((data) => {
      console.log(data);
      setPost(data?.data);
    });
  }, []);
  // const val= await axios.get('http://localhost:3001/getAllSample');
  const pagination = usePagination(post, {
    state: {
      page: 0,
      size: 2,
    },
  });

  return (
    <>
      <Navbar bg="dark" expand="sm">
        <Container>
          <Navbar.Brand href="#">
            <img src={logo} alt="Logo" width={"65px"} height={"50px"} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link>
                <Link to="/">Home</Link>
              </Nav.Link>
              <Nav.Link>
                <Link to={session_role === 'admin' ? '/member' : '/form'}>Dashboard</Link>
              </Nav.Link>
              <Nav.Link>
                <Link to="/survey1">Form</Link>
              </Nav.Link>
              <NavDropdown
                className="dropdown"
                title="Settings"
                menuVariant="dark"
                drop="end"
                id="basic-nav-dropdown">
                <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.3">
                  Edit Profile
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="table">
        <Table pagination={pagination}>
          <Thead className="thead">
            <Tr>
              <Th>Full Name</Th>
              <Th>Sample #</Th>
              <Th>Created At</Th>
              <Th>Total Score</Th>
              <Th>Completed</Th>
              <Th>Status</Th>
            </Tr>
          </Thead>
          {post.map((data) => {
            var inputsWithValue = 0;

            if (
              data.cleancupcups1 === false &&
              data.cleancupcups2 === false &&
              data.cleancupcups3 === false &&
              data.cleancupcups4 === false &&
              data.cleancupcups5 === false
            ) {
              inputsWithValue += 1;
            }
            if (
              data.characterberry === false &&
              data.characterbrownspice === false &&
              data.charactercitric === false &&
              data.charactercoca === false &&
              data.characterdriedfruit === false &&
              data.characterfloral === false &&
              data.characterfruity === false &&
              data.characterherbal === false &&
              data.characternutty === false &&
              data.characteroverripe === false &&
              data.characterstonefruit === false &&
              data.charactertropical === false
            ) {
              inputsWithValue += 1;
            }
            if (
              data.uniformcups1 === false &&
              data.uniformcups2 === false &&
              data.uniformcups3 === false &&
              data.uniformcups4 === false &&
              data.uniformcups5 === false
            ) {
              inputsWithValue += 1;
            }
            if (
              data.sweetcups1 === false &&
              data.sweetcups2 === false &&
              data.sweetcups3 === false &&
              data.sweetcups4 === false &&
              data.sweetcups5 === false
            ) {
              inputsWithValue += 1;
            }
            Object.entries(data).map((t, k) => {
              // console.log("checkkkkkkkkk");
              // console.log(data.characterbrownspice);

              if (t[1] === 0 || t[1] === "") {
                inputsWithValue += 1;
              }
            });
            // console.log(`hellllllllooo${inputsWithValue}`);
            var filledPercentage = 100 - (inputsWithValue / 50) * 100;
            return (
              <Tbody>
                <Tr>
                  <Td>
                    {" "}
                    {data.nameofsurveyer === "" ? " " : data.nameofsurveyer}
                  </Td>
                  <Td>
                    {data.samplecoffeeid === "" ? " " : data.samplecoffeeid}
                  </Td>
                  <Td>{moment(data.createdat).fromNow()}</Td>
                  <Td>{data.finalscore}</Td>
                  <Td> {filledPercentage.toFixed(2)} %</Td>

                  <Td>
                    <Link
                      to="/survey1"
                      state={{ data: data, anotherVariable: "1" }}>
                      Edit
                    </Link>
                    <span style={{ padding: "5px" }}></span>
                    <Link
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() => handleDelete(data.id)}>
                      Delete
                    </Link>
                  </Td>
                </Tr>
              </Tbody>
            );
          })}
        </Table>
      </div>
    </>
  );
};

export default History;
